import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

const names = [
  'Autopeças',
  'Autopeças RET',
  'Construção Civil',
  'Construção Civil RET',
  'Supermercado',
  'Supermercado RET',
];

function getStyles(name, personName, theme) {
  return {
    fontWeight: personName.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}

export default function MultipleSelect({selectedCalculo, setSelectedCalculo}) {
  const theme = useTheme();

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedCalculo(value
    );
  };

  return (
    <div>
      <FormControl fullWidth spacing={3} sx={{ margin: "10px 0 "}}>
        <InputLabel id="demo-multiple-name-label">Cálculo ICMS</InputLabel>
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          fullWidth
          value={selectedCalculo}
          onChange={handleChange}
          input={<OutlinedInput label="Cálculo ICMS" />}
          MenuProps={MenuProps}
        >
          {names.map((name) => (
            <MenuItem
              key={name}
              value={name}
              fullWidth
              style={getStyles(name, selectedCalculo, theme)}
            >
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
